import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { CustomerBillingPriceListData } from '../customer-billing-price-list-data';
import { AppTextService } from '@fi-shared/app-text';
import { CustomerBillingPriceService } from '../customer-billing-price.service';
import { PackageTypes } from '@fi-app/billing/package-type';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IBillingPriceListItemModel } from '@fi-app/customer-billing/customer-billing-price/customer-billing-price.model';
import { createMap } from '@fi-shared/utils/create-map';

@Component({
    selector: 'fi-customer-billing-price-list',
    template: `
        <items-list-actions
            class="fi-absolute fi-padding-left"
            [selectedItems]="selectedItems$ | async"
            [filterType]="ListData.FilterType"
            [itemsListComponent]="itemsListComponent"
            [stateName]="FiStateNames.CustomerBilling.Price.Edit"
        >
        </items-list-actions>
        <fi-items-list #itemsListComponent [settings]="ListData"></fi-items-list>
    `,
    styleUrls: ['./customer-billing-price-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-price-list fi-relative' },
    standalone: false,
})
export class CustomerBillingPriceListComponent
    extends ItemsListContainerBase<CustomerBillingPriceListData>
    implements OnInit
{
    FiStateNames = FiStateNames;

    constructor(
        private appText: AppTextService,
        private priceService: CustomerBillingPriceService,
        private injector: Injector,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(
            () =>
                new CustomerBillingPriceListData(
                    this.injector,
                    this.priceService.DeleteBillingPrices.bind(this.priceService),
                ),
            { showDelete: false },
        );

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
    }

    protected LoadItems(): Promise<void> {
        let packageTypesMap = createMap(PackageTypes, 'Id');
        const self = this;

        const mapData = (data): IBillingPriceListItemModel => {
            if (data.IsModule)
                data.Name = data.Name + ' - ' + self.appText.get(packageTypesMap[data.UsageLevel].TextId);

            if (data.ChildItems) data.ChildItems = data.ChildItems.map(mapData);

            return data;
        };
        return this.priceService.GetBillingPrices().then((response: IBillingPriceListItemModel[]) => {
            this.ListData.appendData(response.map(mapData));
        });
    }
}
